import { render, staticRenderFns } from "./RetailShowroomBulkyGoodsRetailProperty.vue?vue&type=template&id=b9e508c2&scoped=true&"
import script from "./RetailShowroomBulkyGoodsRetailProperty.vue?vue&type=script&lang=ts&"
export * from "./RetailShowroomBulkyGoodsRetailProperty.vue?vue&type=script&lang=ts&"
import style0 from "./RetailShowroomBulkyGoodsRetailProperty.vue?vue&type=style&index=0&id=b9e508c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e508c2",
  null
  
)

export default component.exports